// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EditTestamentaryEntity_IndividualFragment = { __typename?: 'ClientProfile', id: string, displayName: string, legalName: string };

export type GetHouseholdIndividualsForAccountOwnerQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.HouseholdWhereInput>;
}>;


export type GetHouseholdIndividualsForAccountOwnerQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, clientProfiles?: Array<(
          { __typename?: 'ClientProfile' }
          & EditTestamentaryEntity_IndividualFragment
        )> | null } | null } | null> | null } };

export const Operations = {
  Query: {
    GetHouseholdIndividualsForAccountOwner: 'GetHouseholdIndividualsForAccountOwner' as const
  },
  Fragment: {
    EditTestamentaryEntity_Individual: 'EditTestamentaryEntity_Individual' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EditTestamentaryEntity_IndividualFragmentDoc = gql`
    fragment EditTestamentaryEntity_Individual on ClientProfile {
  id
  displayName
  legalName
}
    `;
export const GetHouseholdIndividualsForAccountOwnerDocument = gql`
    query GetHouseholdIndividualsForAccountOwner($where: HouseholdWhereInput) {
  households(where: $where) {
    edges {
      node {
        id
        clientProfiles {
          ...EditTestamentaryEntity_Individual
        }
      }
    }
  }
}
    ${EditTestamentaryEntity_IndividualFragmentDoc}`;

/**
 * __useGetHouseholdIndividualsForAccountOwnerQuery__
 *
 * To run a query within a React component, call `useGetHouseholdIndividualsForAccountOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHouseholdIndividualsForAccountOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHouseholdIndividualsForAccountOwnerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetHouseholdIndividualsForAccountOwnerQuery(baseOptions?: Apollo.QueryHookOptions<GetHouseholdIndividualsForAccountOwnerQuery, GetHouseholdIndividualsForAccountOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHouseholdIndividualsForAccountOwnerQuery, GetHouseholdIndividualsForAccountOwnerQueryVariables>(GetHouseholdIndividualsForAccountOwnerDocument, withFetchPolicyContext(options));
      }
export function useGetHouseholdIndividualsForAccountOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHouseholdIndividualsForAccountOwnerQuery, GetHouseholdIndividualsForAccountOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHouseholdIndividualsForAccountOwnerQuery, GetHouseholdIndividualsForAccountOwnerQueryVariables>(GetHouseholdIndividualsForAccountOwnerDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetHouseholdIndividualsForAccountOwnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHouseholdIndividualsForAccountOwnerQuery, GetHouseholdIndividualsForAccountOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHouseholdIndividualsForAccountOwnerQuery, GetHouseholdIndividualsForAccountOwnerQueryVariables>(GetHouseholdIndividualsForAccountOwnerDocument, withFetchPolicyContext(options));
        }
export type GetHouseholdIndividualsForAccountOwnerQueryHookResult = ReturnType<typeof useGetHouseholdIndividualsForAccountOwnerQuery>;
export type GetHouseholdIndividualsForAccountOwnerLazyQueryHookResult = ReturnType<typeof useGetHouseholdIndividualsForAccountOwnerLazyQuery>;
export type GetHouseholdIndividualsForAccountOwnerSuspenseQueryHookResult = ReturnType<typeof useGetHouseholdIndividualsForAccountOwnerSuspenseQuery>;
export type GetHouseholdIndividualsForAccountOwnerQueryResult = Apollo.QueryResult<GetHouseholdIndividualsForAccountOwnerQuery, GetHouseholdIndividualsForAccountOwnerQueryVariables>;